import { KeyValue } from '@angular/common';
import _ from 'lodash';

import { FormBase } from 'src/app/shared/models/application/formBase';
import { RankedKeyValues } from 'src/app/shared/models/attributes/rankedKeyValues';

export class PersonApplication extends FormBase {
  public workspaceId: string;
  public applicationId: string;
  public isCompleted: boolean;
  public completedDate: Date;
  public sentDate: Date;
  public submissionDate: Date;
  public clickedOn: Date;
  public secureLinkId: string;
  public requestUri: string;
  public teamName: string;
  public formType: string;
  public isFirmForm: boolean;

  public customFieldsSnapshot: Array<RankedKeyValues> = new Array<RankedKeyValues>();
  public systemFieldsSnapshot: Array<KeyValue<string, string>> = new Array<
    KeyValue<string, string>
  >();

  public static parse(data: any): PersonApplication {
    if (!data) return null;

    let app = new PersonApplication();
    app.id = data.id;
    app.workspaceId = data.workspaceId;
    app.title = data.title;
    app.publicTitle = data.publicTitle;
    app.completedDate = data.completedDate;
    app.isCompleted = data.isCompleted;
    app.applicationId = data.applicationId;
    app.sentDate = data.sentDate;
    app.submissionDate = data.submissionDate;
    app.clickedOn = data.clickedOn;
    app.secureLinkId = data.secureLinkId;
    app.requestUri = data.requestUri;
    app.teamName = data.teamName;
    app.formType = data.formType;
    app.isFirmForm = data.isFirmForm ?? false;

    if (data.customFieldsSnapshot) {
      app.customFieldsSnapshot = _.map(data.customFieldsSnapshot, (rkv) =>
        RankedKeyValues.parse(rkv)
      );
    }

    if (data.systemFieldsSnapshot) {
      app.systemFieldsSnapshot = data.systemFieldsSnapshot;
    }

    return app;
  }

  getTeamNameSuffix() {
    return this.teamName ? `(${this.teamName})` : '';
  }
}
